import { render, staticRenderFns } from "./Upsell.vue?vue&type=template&id=53affc3c&scoped=true"
import script from "./Upsell.vue?vue&type=script&lang=js"
export * from "./Upsell.vue?vue&type=script&lang=js"
import style0 from "./Upsell.vue?vue&type=style&index=0&id=53affc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53affc3c",
  null
  
)

export default component.exports